import React from "react";
import Icon, { type IconProps } from "./Icon";
/** Plus — Lucide. https://lucide.dev/icons/plus (MIT). Copied 2026-05-16.
 *  Phase 3d: AdminAudit user.create scope marker. */
export default function Plus(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </Icon>
  );
}
